import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function List2({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <g fill="none" fillRule="evenodd">
        <circle className={theme.fill} cx="20" cy="20" r="20" />
        <path
          className={cx(theme.numberFill, theme.secondFill)}
          d="M24.642 27.151h-8.996v-1.784l4.246-4.526c.583-.637 1.014-1.193 1.293-1.667.28-.475.42-.926.42-1.352 0-.583-.148-1.042-.442-1.375-.295-.334-.715-.5-1.262-.5-.59 0-1.053.202-1.393.608-.34.406-.51.939-.51 1.6h-2.613c0-.8.19-1.53.572-2.19a4.034 4.034 0 0 1 1.618-1.555c.697-.376 1.487-.564 2.37-.564 1.353 0 2.403.325 3.151.974.749.649 1.123 1.565 1.123 2.75 0 .648-.169 1.31-.505 1.982-.337.673-.914 1.458-1.73 2.353l-2.985 3.146h5.643v2.1z"
        />
      </g>
    </svg>
  )
}

List2.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
